import { createAction } from 'redux-actions';

import { wrapFetch } from 'actions/endpoint';
import { openFailedAlert } from 'actions/alert';
import { updateRoomByApartment } from 'actions/room';

import { keyTransform } from 'util/helper';
import { defaultApartmentData } from 'reducers/apartment';

export const updateApartment = createAction(
	'UPDATE_APARTMENT',
	apartment => (dispatch, getState) => {
		const newApartment = keyTransform(apartment);
		const oldApartment = getState().apartment.data[newApartment.id] || defaultApartmentData;

		newApartment.rooms.forEach(room => dispatch(updateRoomByApartment(room)));

		return {
			[newApartment.id]: {
				...defaultApartmentData,
				...oldApartment,
				...newApartment,
				rooms: newApartment.rooms.map(({ id }) => id),
			},
		};
	},
);

export const updateApartmentByRoom = createAction(
	'UPDATE_APARTMENT',
	(apartment, roomId) => (_, getState) => {
		const newApartment = keyTransform(apartment);
		const oldApartment = getState().apartment.data[newApartment.id] || defaultApartmentData;

		return {
			[newApartment.id]: {
				...defaultApartmentData,
				...oldApartment,
				...newApartment,
				rooms: [...oldApartment.rooms, roomId],
			},
		};
	},
);

export const getApartmentById = createAction('FETCH_APARTMENT_BY_ID', id => async dispatch => {
	const { status, message, data } = await wrapFetch(`apartment/${id}`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const newData = keyTransform(data.data);
	dispatch(updateApartment(newData));

	const recommend = data.recommend.map(item => {
		dispatch(updateApartment(keyTransform(item)));

		return item.id;
	});

	return { recommend };
});

export const getApartment = createAction('FETCH_APARTMENT', () => async dispatch => {
	const { status, message, data } = await wrapFetch('apartment', {
		method: 'GET',
	});

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const newData = {};
	const list = data.map(item => {
		newData[item.id] = keyTransform(item);

		newData[item.id].rooms.forEach(room => dispatch(updateRoomByApartment(room)));

		newData[item.id].rooms = newData[item.id].rooms.map(({ id }) => id);

		return item.id;
	});

	return {
		list,
		data: newData,
	};
});



// WEBPACK FOOTER //
// ./src/actions/apartment.js